import React, { useEffect, useRef, useState } from 'react';

const ProjectCard = ({ project, delay }) => {
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef(null);

  const getProjectLogo = (number) => {
  switch(number) {
    case '01':
      // ML Brain/Network logo
      return (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="40" cy="20" r="8" stroke="#5DADE2" strokeWidth="2.5" fill="none"/>
          <circle cx="20" cy="45" r="8" stroke="#5DADE2" strokeWidth="2.5" fill="none"/>
          <circle cx="60" cy="45" r="8" stroke="#5DADE2" strokeWidth="2.5" fill="none"/>
          <circle cx="40" cy="60" r="8" stroke="#5DADE2" strokeWidth="2.5" fill="none"/>
          <line x1="40" y1="28" x2="40" y2="52" stroke="#87CEEB" strokeWidth="2"/>
          <line x1="35" y1="25" x2="23" y2="40" stroke="#87CEEB" strokeWidth="2"/>
          <line x1="45" y1="25" x2="57" y2="40" stroke="#87CEEB" strokeWidth="2"/>
          <line x1="26" y1="50" x2="34" y2="56" stroke="#87CEEB" strokeWidth="2"/>
          <line x1="54" y1="50" x2="46" y2="56" stroke="#87CEEB" strokeWidth="2"/>
        </svg>
      );
    case '02':
      // React logo
      return (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="40" cy="40" r="6" fill="#5DADE2"/>
          <ellipse cx="40" cy="40" rx="28" ry="12" stroke="#87CEEB" strokeWidth="2.5" fill="none"/>
          <ellipse cx="40" cy="40" rx="28" ry="12" stroke="#87CEEB" strokeWidth="2.5" fill="none" transform="rotate(60 40 40)"/>
          <ellipse cx="40" cy="40" rx="28" ry="12" stroke="#87CEEB" strokeWidth="2.5" fill="none" transform="rotate(-60 40 40)"/>
        </svg>
      );
    case '03':
      // Database server logo
      return (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="40" cy="25" rx="18" ry="6" fill="#B0E0F6" stroke="#5DADE2" strokeWidth="2"/>
          <path d="M22 25 L22 35 Q22 38 40 38 Q58 38 58 35 L58 25" stroke="#5DADE2" strokeWidth="2" fill="none"/>
          <ellipse cx="40" cy="35" rx="18" ry="3" fill="#87CEEB"/>
          <path d="M22 35 L22 45 Q22 48 40 48 Q58 48 58 45 L58 35" stroke="#5DADE2" strokeWidth="2" fill="none"/>
          <ellipse cx="40" cy="45" rx="18" ry="3" fill="#87CEEB"/>
          <path d="M22 45 L22 55 Q22 58 40 58 Q58 58 58 55 L58 45" stroke="#5DADE2" strokeWidth="2" fill="none"/>
          <ellipse cx="40" cy="55" rx="18" ry="3" fill="#87CEEB"/>
        </svg>
      );
    default:
      return <div className="project-card__placeholder">{number}</div>;
  }
};

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      {
        threshold: 0.15
      }
    );

    const currentRef = cardRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <a
      href="https://github.com/Saad259" 
      ref={cardRef}
      className={`project-card project-card--${project.direction} ${isVisible ? 'project-card--visible' : ''}`}
      style={{ animationDelay: `${delay}s` }}
    >
      <div className="project-card__image">
        {getProjectLogo(project.number)}
      </div>
      <h3 className="project-card__title">{project.title}</h3>
      <p className="project-card__description">{project.description}</p>
      {project.techStack && (
      <div className="project-card__tech-stack">
          {project.techStack.map((tech, index) => (
            <span key={index} className="project-card__tech">{tech}</span>
          ))}
        </div>
      )}
    </a>
  );
};

export default ProjectCard;
